import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GpBankAccountDataService } from 'src/app/services/gp/gp-bank-account-data.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { LoggerService } from '../../errors/logger.service';
import { PaymentType } from '../../enums/payment-type.enum';

export class ClientBankAccountDetailsDialogParams {
  clientBankAccountId: number;
  title = 'Bank Account Details';
}
@Component({
  selector: 'terra-client-bank-account-details-dialog',
  templateUrl: './client-bank-account-details-dialog.component.html',
  styleUrls: ['./client-bank-account-details-dialog.component.scss']
})
export class ClientBankAccountDetailsComponent implements OnInit {

  readonly cantDisplayDetailsMessage = `An error occurred. Unable to display bank account details.`;

  PaymentType = PaymentType

  bankAccountDetails$ = this.gpBankAccountDataService.getById(this.data.clientBankAccountId).pipe(
    catchError(err => {
      this.logger.error('ClientBankAccountDetailsComponent => bankAccountDetails$',err);
      this.snackbarService.showGeneralMessage(this.cantDisplayDetailsMessage);
      this.dialogRef.close();
      return throwError(err);
    })
  );

  constructor(
    private gpBankAccountDataService: GpBankAccountDataService,
    public dialogRef: MatDialogRef<ClientBankAccountDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ClientBankAccountDetailsDialogParams,
    private logger: LoggerService,
    private snackbarService: SnackbarService
  ) {
    if (!data) {
      console.log('ERROR: missing data, and clientBankAccountId');
      data = new ClientBankAccountDetailsDialogParams();
    }
  }

  ngOnInit() {

  }
}
